<template>
  <create-team-layout>
    <template v-slot:create-team-name>
      <create-team-name :team-name.sync="teamName" />
    </template>
    <template v-slot:common-account-select-wrapper>
      <account-select-wrapper ref="accountSelectWrapper" @operate="operate" :contacts="imQyhContactData" />
    </template>
<!--    <button @click="createTeam">创建</button>-->
  </create-team-layout>
</template>

<script>
import CreateTeamLayout from './CreateTeamLayout.vue'
import CreateTeamName from './CreateTeamName.vue'
import AccountSelectWrapper from '../AccountSelectWrapper.vue'
import { mapState } from 'vuex'
export default {
  name: 'CreateTeam',
  components: {
    CreateTeamName,
    CreateTeamLayout,
    AccountSelectWrapper
  },
  props: {
  },
  data () {
    return {
      teamName: ''
    }
  },
  computed: {
    ...mapState({
      imQyhContactData: state => state.imQyhContactData
    }),
  },
  watch: {
  },
  methods: {
    updateTeamName (value) {
      this.teamName = value
    },
    operate (checkList) {
      if (!this.teamName) return this.$message.error('请输入群名')
      let teamInfo = {
        name: this.teamName,
        accounts: checkList.map(item => item.im_accid),
        intro: '铁道游击队情报组织处',
        announcement: '欢迎加入铁道游击队狡兔一窟',
        ps: this.teamName + '成立了！'
      }
      this.$store.dispatch('createTeam', teamInfo)
      this.$refs.accountSelectWrapper.clearData()
      console.log('ok', teamInfo)
    }
  }
}
</script>

<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/common/im/team/create/CreateTeam.vue